import { LinearProgress } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ProgressBar = styled(LinearProgress)(({ theme }) => ({
  height: '6px',
  borderRadius: '10px',
  backgroundColor: theme.tokens.ThemeColorCommonSeparator,
  '@media (prefers-reduced-motion: reduce)': {
    '& .MuiLinearProgress-bar': {
      transition: 'none',
    },
  },
}))
